import envConfig from "./EnvironmentConfigs";

const keycloakConfig = {
  url: envConfig.keycloakUrl,
  realm: envConfig.keycloakRealm,
  clientId: envConfig.keycloakClientId,
};

export default keycloakConfig;
